import type React from 'react'
import { Avatar, Tooltip } from 'antd'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import type { SupplierConfig } from '../../../../../api/useSupplierReconciliation'
import type { SupplierConfigMetadataResponse } from '../../../../../api/useMetadata/types'

interface Assignee {
  username: string
  name?: string
  email?: string
}

interface UserAssignmentCellProps {
  value: string | null
  data: SupplierConfig
  context: {
    users: SupplierConfigMetadataResponse['users']
    metadata?: SupplierConfigMetadataResponse
  }
}

function getInitials(name: string) {
  if (!name) return ''
  return name
    .split(' ')
    .map((part) => part?.[0] || '')
    .join('')
    .toUpperCase()
}

export function UserAssignmentCell({ value, context, data }: UserAssignmentCellProps) {
  if (!value) {
    return <Texto appearance='hint'>Not Assigned</Texto>
  }
  // Use metadata.users if available, otherwise fall back to context.users
  const users = context.metadata?.users || context.users
  const user = users.find((user) => user.username === value)

  const displayName = user?.name || user?.username || value

  return (
    <Horizontal gap={8} alignItems='center'>
      <Tooltip title={displayName}>
        <Avatar style={{ backgroundColor: 'var(--theme-color-2)' }} size='small'>
          {getInitials(displayName)}
        </Avatar>
      </Tooltip>
      <Texto>{displayName}</Texto>
    </Horizontal>
  )
}
